import axios, { AxiosError, AxiosResponse } from 'axios';

interface RegisterAuthInterceptorsOptions {
    getToken: () => string | undefined;
    getAllowedOrigins: () => string | undefined;
    onUnauthorized: () => void | Promise<void>;
}

const registerAuthInterceptors = ({
    getToken,
    getAllowedOrigins,
    onUnauthorized,
}: RegisterAuthInterceptorsOptions) => {
    const requestInterceptor = axios.interceptors.request.use(
        (config: any) => {
            const { origin } = new URL(config.url ?? '');
            const allowedOrigins = getAllowedOrigins();
            const token = getToken();

            if (token && allowedOrigins?.includes(origin)) {
                const headers = config.headers ?? {};
                config.headers = {
                    ...headers,
                    authorization: `Bearer ${token}`,
                };
            }

            if (config.method === 'delete' && !config.data) {
                config.data = { delete: true };
            } else if (config.method === 'post' && !config.data) {
                config.data = {};
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    const responseInterceptor = axios.interceptors.response.use(
        (response: AxiosResponse<any, any>) => response,
        async (err: AxiosError) => {
            if (err?.response?.status === 401) {
                await onUnauthorized();
            }

            return Promise.reject(err);
        }
    );

    return () => {
        axios.interceptors.request.eject(requestInterceptor);
        axios.interceptors.response.eject(responseInterceptor);
    };
};

export default registerAuthInterceptors;